import HeroSection from "./HeroSection";
import TextSection from "./TextSection";
import CardGridSection from "./CardGridSection";
import ContactFormSection from "./ContactFormSection";
import SponsorLogosSection from "./SponsorLogosSection";
import EventsSection from "./EventsSection";
import TeamSection from "./TeamSection";
import FastgiverSection from "./FastgiverSection";
import VideoFeatureSection from "./VideoFeatureSection";
import type { Section } from "@/data/site-content.types";

interface SectionRendererProps {
  sections: Section[];
}

const SectionRenderer = ({ sections }: SectionRendererProps) => {
  return (
    <>
      {sections.map((section) => {
        switch (section.type) {
          case "hero":
            return (
              <HeroSection
                key={section.key}
                heading={section.heading}
                body={section.body}
                image={section.image}
                localImage={section.localImage}
                cta={section.cta}
              />
            );
          case "text":
            return (
              <TextSection
                key={section.key}
                heading={section.heading}
                body={section.body}
                cta={section.cta}
              />
            );
          case "card-grid":
            return (
              <CardGridSection
                key={section.key}
                heading={section.heading}
                items={section.items}
              />
            );
          case "contact-form":
            return (
              <ContactFormSection
                key={section.key}
                heading={section.heading}
                body={section.body}
              />
            );
          case "sponsor-logos":
            return <SponsorLogosSection key={section.key} />;
          case "events":
            // Events come from Supabase now (admin-managed). The section.events
            // field in site-content.json is ignored — kept only for legacy
            // type compatibility.
            return <EventsSection key={section.key} heading={section.heading} />;
          case "team":
            return (
              <TeamSection
                key={section.key}
                heading={section.heading}
                members={section.members}
              />
            );
          case "fastgiver":
            return (
              <FastgiverSection
                key={section.key}
                heading={section.heading}
                body={section.body}
              />
            );
          case "video-feature":
            return (
              <VideoFeatureSection
                key={section.key}
                heading={section.heading}
                body={section.body}
                eyebrow={section.eyebrow}
                sources={section.sources}
                poster={section.poster}
                reverse={section.reverse}
              />
            );
          default: {
            const _exhaustive: never = section;
            return _exhaustive;
          }
        }
      })}
    </>
  );
};

export default SectionRenderer;
